module.exports = __webpack_public_path__ + "static/media/jump-page-pl.51acdcc3.png";